import { useCallback, useContext, useState } from 'react'
import styled from 'styled-components'

import ContainerAbsolute from '../basic-components/ContainerAbsolute'
import EmailNotesPage from '../notes-page/EmailNotesPage'
import DisclaimerPage from '../disclaimer-page/DisclaimerPage'
import HelpPage from '../help-page/HelpPage'
import LayersPage from '../layers-page/LayersPage'
import MapOverlay from '../map-page/MapOverlay'
import MenuPage from '../menu-page/MenuPage'
import Modal from '../basic-components/Modal'
import NotePage from '../notes-page/NotePage'
import NotesPage from '../notes-page/NotesPage'
import ParcelDetailPage from '../parcel-detail-page/ParcelDetailPage'
import SearchResultsPage from '../search-results-page/SearchResultsPage'
import UnknownPage from '../unknown-page/UnknownPage'

import MapContext from '../context/MapContext'
import QueryContext from '../context/QueryContext'

import menuItems from '../configuration/menuItems'
import startPage from '../configuration/startPage'

const Container = styled(ContainerAbsolute)`
  display: flex;
  flex-direction: column;
  flex: 1;
  pointer-events: none;
  /*border: 2px solid red;*/
`

export default function OverlayControl() {
  const { showResultOnMap } = useContext(MapContext);
  const { queryData } = useContext(QueryContext);

  // navigation state
  const [ currentPage, setCurrentPage ] = useState(startPage);
  const [ previousPages, setPreviousPages ] = useState([]);

  // SearchResultsPage state
  const [ open, setOpen ] = useState(true);
  const [ results, setResults ] = useState(null);
  const [ searchParams, setSearchParams ] = useState({});

  // ParcelDetailPage state
  const [ parcelSearchParams, setParcelSearchParams ] = useState(null);
  const [ searchType, setSearchType ] = useState('');

  // NotePage state
  const [ currentNoteId, setCurrentNoteId ] = useState(null);

  // NotesPage state
  const [ editingList, setEditingList ] = useState(false);

  // Modal State
  const [ modalOpen, setModalOpen ] = useState(false);

  const gotoMap = useCallback(
    (pushCurrent=false) => {
      //console.log(previousPages);
      if (pushCurrent) {
        setPreviousPages([...previousPages, currentPage]);
      }
      setCurrentPage({value: 'map-page'});
    },
    [ currentPage, previousPages ]
  );

  const gotoMenu = () => {
    setOpen(true);
    setResults(null);
    setSearchParams({});
    setPreviousPages([]);
    setCurrentPage({value: 'menu-page'});
  }

  const goToNote = (id) => {
    setCurrentNoteId(id);
    setPreviousPages([...previousPages, currentPage]);
    setCurrentPage({value: 'note-page'});
  }

  const gotoParcelDetail = (type, params) => {
    //console.error('gotoParcelDetail');
    setPreviousPages([...previousPages, currentPage]);
    //console.log(type, params);
    setSearchType(type);
    setParcelSearchParams(params);
    setCurrentPage({value: 'parcel-detail-page'});
  }

  const backClickHandler = () => {
    //console.warn('** backClickHandler **');
    //console.log(previousPages);
    const nextPage = previousPages.pop();
    setCurrentPage(nextPage);
  }

  const crosshairsClickHandler = () => {
    setPreviousPages([...previousPages, currentPage]);
    //console.log(queryData);
    if (queryData) {
      showResultOnMap(queryData);
    } else {
      // show modal with note of "no query location available"
      setModalOpen(true);
    }
    setCurrentPage({value: 'map-page'});
  }

  const disclaimerClickHandler = () => {
    gotoMenu();
  }

  const layersClickHandler = () => {
    //setPreviousPages([...previousPages, currentPage]);
    setCurrentPage({value: 'layers-page'});
  }

  const menuChangeHandler = (selectedItem) => {
    //console.warn('onMenuChange');
    //console.log(currentPage);
    //console.log(previousPages);
    setPreviousPages([...previousPages, currentPage]);
    setCurrentPage(selectedItem)
  }

  //console.warn('before switch');
  //console.log(currentPage);
  //console.log(currentPage.value);
  //console.log(previousPages);

  //console.log('** search state **');
  //console.log(open, results, searchParams);

  let displayPage = null;
  switch (currentPage.value) {
    case 'email-notes-page':
      displayPage = ( <EmailNotesPage onBackClick={backClickHandler} /> );
      break;

    case 'help-page':
      displayPage = ( <HelpPage onBackClick={gotoMenu} /> );
      break;

    case 'layers-page':
      displayPage = (
        <LayersPage
          onBackClick={() => setCurrentPage({value: 'map-page'})}
        />
      );
      break;

    case 'map-page':
      displayPage = (
        <MapOverlay
          onBackClick={backClickHandler}
          onDoubleBackClick={gotoMenu}
          onCrosshairsClick={crosshairsClickHandler}
          onLayersClick={layersClickHandler}
          goToNote={goToNote}
        />
      );
      break;

    case 'menu-page':
      displayPage = (
        <MenuPage
          menuItems={menuItems}
          onChange={menuChangeHandler}
        />
      );
      break;

    case 'note-page':
      displayPage = (
        <NotePage
          currentNoteId={currentNoteId}
          gotoMap={gotoMap}
          onBackClick={backClickHandler}
        />
      );
      break;

    case 'notes-page':
      displayPage = (
        <NotesPage
          editingList={editingList}
          setEditingList={setEditingList}
          onBackClick={backClickHandler}
          onSendEmailClick={(checkedNotes) => {
            setPreviousPages([...previousPages, currentPage]);
            setCurrentPage({value: 'email-notes-page'});
          }}
          onItemClick={(id) => {
            setCurrentNoteId(id);
            setPreviousPages([...previousPages, currentPage]);
            setCurrentPage({value: 'note-page'});
          }}
        />
      );
      break;

    case 'parcel-detail-page':
      displayPage = (
        <ParcelDetailPage
          searchType={searchType}
          parcelSearchParams={parcelSearchParams}
          gotoMap={gotoMap}
          onBackClick={backClickHandler}
          onDoubleBackClick={gotoMenu}
          onCrosshairsClick={crosshairsClickHandler}
        />
      );
      break;

    case 'search-results-page':
      displayPage = (
        <SearchResultsPage
          searchType={currentPage.text}
          gotoParcelDetail={gotoParcelDetail}
          onBackClick={gotoMenu}
          state={{open, setOpen, results, setResults}}
        />
      );
      break;

    case 'start-page':
      displayPage = (
        <DisclaimerPage onClick={disclaimerClickHandler} />
      );
      break;

    default:
      displayPage = (
        <UnknownPage
          page={currentPage}
          onBackClick={backClickHandler}
        />
      );
      //console.error('Unknown Page: ' + currentPage.value);
      //console.log(currentPage);
      // throw exception here?
      // or show error and back button
  }

  //console.warn('rendering Overlay ***********');
  //console.log(currentPage);
  //console.log(previousPages);

  // TODO: fix modal contents format

  return (
    <>
    <Container>
     {displayPage}
    </Container>

    <Modal
      open={modalOpen}
      showCloseIcon={false}
      closeOnOverlayClick={false}
      onClose={() => setModalOpen(false)}
    >
      <div>
      No Query Location Available &nbsp;
      <button onClick={() => setModalOpen(false)} >OK</button>
      </div>

    </Modal>
    </>
  );

}
